/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_ContactInputs */

const es_privacy_policy_rights_contact = /** @type {(inputs: Privacy_Policy_Rights_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ejercer estos derechos, contactenos en:`)
};

const en_privacy_policy_rights_contact = /** @type {(inputs: Privacy_Policy_Rights_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To exercise these rights, contact us at:`)
};

/**
* | output |
* | --- |
* | "To exercise these rights, contact us at:" |
*
* @param {Privacy_Policy_Rights_ContactInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_contact = /** @type {((inputs?: Privacy_Policy_Rights_ContactInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_ContactInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_contact(inputs)
	return en_privacy_policy_rights_contact(inputs)
});
export { privacy_policy_rights_contact as "privacy_policy.rights.contact" }